export const downloadBlob = (blob: Blob, filename: string) => {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = objectUrl;
    link.download = filename;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(objectUrl);
};

const escapeCsvField = (field: string): string => {
    if (field.includes(",") || field.includes('"') || field.includes("\n")) {
        const escapedField = field.replace(/"/g, '""');
        return `"${escapedField}"`;
    }
    return field;
};

export const downloadCsv = (rows: string[][], filename: string) => {
    const csvContent = rows.map((row) => row.map(escapeCsvField).join(",")).join("\r\n");
    const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
    downloadBlob(blob, filename);
};
